export const CONCEPTS = {
  today: {
    title: "Today",
    purpose: "Answers “Who needs me today?” the moment the app opens — before any menu or number.",
    shows: [
      "A personal greeting and one plain sentence: how many people need you today",
      "One card per person, always in this order: name → why → last connected → what's needed next",
      "Call, Text and Log care right on the card",
      "“When you have a moment” — someone outside the church's care rhythm",
      "Cared for today, then Coming up this week",
    ],
    hierarchy: ["The sentence", "People to care for (past-due first, then due today)", "A gentle rhythm prompt", "What's coming"],
    primary: "Log care — usually right after tapping Call or Text",
    removed: ["Stats, charts and KPI tiles", "Filters, sorting and menus", "Red “overdue” alarms — we say “Was due Thursday”", "Notification bell and inbox"],
  },
  people: {
    title: "People / My People",
    purpose: "Find anyone in my care in seconds, and quietly see who might be slipping.",
    shows: [
      "Search first, then three simple filters",
      "Three groups, each with one line of explanation; people needing action sort to the top",
      "Each row: name (strongest) → why they may need care → last meaningful contact → next action (a pill only when action is needed) → care owner for pastors",
      "Care Leaders: “Can't find someone? Ask to have them added” (prevents duplicates)",
      "Pastors: Add person, plus who cares for each person",
    ],
    hierarchy: ["Search", "People in active care", "People in the normal rhythm", "Request / add"],
    primary: "Tap a person (or search)",
    terms: ["A — Active care · Staying connected · Not tracked", "B — Active care · Regular care · Not in reminders", "C — Needs care now · Ongoing care · Paused"],
    removed: ["Tables and columns", "Activity text as the title (“Harold Phone call 2 days ago”)", "Bulk actions (desktop pastor view later)", "Tags and custom fields"],
  },
  person: {
    title: "Person profile",
    purpose: "Everything a leader needs to care for this person well — on one calm page, never an isolated record.",
    shows: [
      "Who they are: a large photo and name as the emotional center, then age · household",
      "Care facts beneath, never in the title: Last connected (Phone call · 2 days ago) and current care state",
      "How to reach them: Call, Text, Email",
      "Who owns the next step, what it is, and when",
      "What's going on: open care needs",
      "Their story: a timeline of care",
      "The household: everyone in the family from Planning Center, with relationships",
      "Confidential notes behind their own tab and permission",
      "Planning Center details, collapsed and read-only",
    ],
    hierarchy: ["Person (photo + name)", "Why they need care", "What happens next + who owns it", "Story", "Household", "Confidential (gated)", "Planning Center details"],
    primary: "Log care",
    removed: ["Edit forms for Planning Center fields", "Giving, attendance and demographics", "Audit metadata on the page", "More than two tabs"],
  },
  log: {
    title: "Log care",
    purpose: "Record what happened and set the next step in about 15 seconds.",
    shows: [
      "How did you connect? — five large choices",
      "Anything the care team should know? — one optional note",
      "Follow up again? — Tomorrow, 3 days, 1 week, Choose date, No follow-up",
      "Save, then a short thank-you that confirms the next step",
    ],
    hierarchy: ["Who it's for", "How", "Note", "Next step", "Save"],
    primary: "Save",
    removed: ["Categories, durations and outcome scores", "Required fields beyond “how”", "A separate follow-up form", "A “mark as confidential” switch — confidential notes live in their own protected tab so nothing is exposed by accident"],
  },
  overview: {
    title: "Pastor Overview",
    purpose: "A calm pastoral dashboard that answers: How are we doing? What is changing? Where are the gaps? What needs my attention?",
    shows: [
      "How are we doing: care coverage, people needing attention, people reached this month, unassigned care needs — each with gentle movement (↑ 4% this month)",
      "Where are the gaps: unassigned care needs (assign inline), past-due follow-ups, people outside the rhythm, people without a caregiver",
      "What is changing: one 12-week trend you can switch, plus three plain-language movement statements",
      "Your care team: leaders grouped as May need support · A few people need attention · All caught up (alphabetical within groups, never ranked), with human support language",
      "Assign menu gives context: “12 people entrusted · 2 need attention”, “All caught up”, team led",
      "Every number opens the exact people behind it, with Assign or Remind on each row",
    ],
    hierarchy: ["One sentence + “See the people who could use attention”", "Health", "Gaps", "Change", "Leaders"],
    primary: "Open the people behind a number, then Assign or Remind",
    removed: ["Leaderboards, rankings and per-leader scores", "Many charts — one switchable trend", "Numbers you can't act on", "Exports and filters (later)"],
  },
};
